








import { Component, Vue, Prop } from 'vue-property-decorator';
import { colors } from '../../styles/constants';
import { speak } from '../../services/TextSpeechService';


@Component
export default class SpeakerIconComponent extends Vue {
    @Prop({ default: ''}) public text!: string;


    public speak() {
        speak(this.text);
    }

    get iconColor() {
        return colors.ffGreen;
    }
}
